export default function isDateBetween(check: Date, to: Date, from: Date) {
  return check.getTime() <= to.getTime() && check.getTime() >= from.getTime();
}
